import { usersList, roleList } from "constants/users";

const initialState = {
  usersList: {},
  roleList: {},
};

const users = (state = initialState, action) => {
  switch (action.type) {
    case usersList:
      return { ...state, usersList: action.payload };

    case roleList:
      return { ...state, roleList: action.payload };

    default:
      return state;
  }
};

export default users;
